import React from "react"
import { useFormikContext } from "formik"
import { type ReservationFormValues } from "@/pages/public/venue"
import VenueDetailsCard from "../venue_details_card"
import { STYLES } from "./_styles"

interface Table {
  id: string
  name: string
  minCapacity?: number | null
  maxCapacity?: number | null
  tableGroup: {
    id: string
    name: string
  }
}

interface ReservationDetailsWithoutMapProps {
  tables: Table[]
  venueName: string
  venueLogoUrl?: string | null
  address?: string | null
  city?: string | null
}

const ReservationDetailsWithoutMap: React.FC<ReservationDetailsWithoutMapProps> = ({
  tables,
  venueName,
  venueLogoUrl,
  address,
  city,
}) => {
  const { values } = useFormikContext<ReservationFormValues>()

  return (
    <div className={STYLES.content} data-testid="public-reservation-modal-details-no-map-container">
      <div className={STYLES.formContainer}>
        <div className={STYLES.detailsColumn}>
          <VenueDetailsCard
            venueName={venueName}
            venueLogoUrl={venueLogoUrl}
            address={address}
            city={city}
            date={values.date}
            startTime={values.startTime}
            endTime={values.endTime}
            peopleAmount={values.peopleAmount}
            tableName={tables.find((t) => t.id === values.tableId)?.name}
            tableGroupName={tables.find((t) => t.id === values.tableId)?.tableGroup.name}
          />
        </div>
      </div>
    </div>
  )
}

export default ReservationDetailsWithoutMap
